import { render, staticRenderFns } from "./ActiveClaims.vue?vue&type=template&id=067082fc&"
import script from "./ActiveClaims.vue?vue&type=script&lang=js&"
export * from "./ActiveClaims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports